import Vue from 'vue'

import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'

/* Plugins */

import nuxt_plugin_plugin_76d36eb1 from 'nuxt_plugin_plugin_76d36eb1' // Source: ./composition-api/plugin.mjs (mode: 'all')
import nuxt_plugin_gtm_61dc9896 from 'nuxt_plugin_gtm_61dc9896' // Source: ./gtm.js (mode: 'all')
import nuxt_plugin_nuxtgooglemaps_2127ab50 from 'nuxt_plugin_nuxtgooglemaps_2127ab50' // Source: ./nuxt-google-maps.js (mode: 'all')
import nuxt_plugin_nuxtplugin4d800aaa_1c9599e0 from 'nuxt_plugin_nuxtplugin4d800aaa_1c9599e0' // Source: ./nuxt.plugin.4d800aaa.js (mode: 'server')
import nuxt_plugin_vuescrollto_6895240a from 'nuxt_plugin_vuescrollto_6895240a' // Source: ./vue-scrollto.js (mode: 'client')
import nuxt_plugin_cookieuniversalnuxt_3d92b2c7 from 'nuxt_plugin_cookieuniversalnuxt_3d92b2c7' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_pluginutils_7e4fbefc from 'nuxt_plugin_pluginutils_7e4fbefc' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_41470572 from 'nuxt_plugin_pluginrouting_41470572' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_d16868f0 from 'nuxt_plugin_pluginmain_d16868f0' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_httpserver_6f06d2cc from 'nuxt_plugin_httpserver_6f06d2cc' // Source: ./http.server.js (mode: 'server')
import nuxt_plugin_http_488ac151 from 'nuxt_plugin_http_488ac151' // Source: ./http.js (mode: 'all')
import nuxt_plugin_axios_9aed9dc2 from 'nuxt_plugin_axios_9aed9dc2' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_googleanalytics_5e6ee4b2 from 'nuxt_plugin_googleanalytics_5e6ee4b2' // Source: ./google-analytics.js (mode: 'client')
import nuxt_plugin_distplugin87244256_77aab419 from 'nuxt_plugin_distplugin87244256_77aab419' // Source: ./dist.plugin.87244256.mjs (mode: 'all')
import nuxt_plugin_image_c4dfa3cc from 'nuxt_plugin_image_c4dfa3cc' // Source: ./image.js (mode: 'all')
import nuxt_plugin_coreplugin1377311c_6ea4e2de from 'nuxt_plugin_coreplugin1377311c_6ea4e2de' // Source: ./core.plugin.1377311c.ts (mode: 'all')
import nuxt_plugin_pluginse2etesting1ce0c5d2_551ed11b from 'nuxt_plugin_pluginse2etesting1ce0c5d2_551ed11b' // Source: ./plugins.e2e-testing.1ce0c5d2.js (mode: 'all')
import nuxt_plugin_deviceplugin_3ba939aa from 'nuxt_plugin_deviceplugin_3ba939aa' // Source: ./device.plugin.js (mode: 'all')
import nuxt_plugin_tokenexpired_ca1e20ca from 'nuxt_plugin_tokenexpired_ca1e20ca' // Source: ../plugins/token-expired (mode: 'all')
import nuxt_plugin_i18n_6a80ea94 from 'nuxt_plugin_i18n_6a80ea94' // Source: ../plugins/i18n (mode: 'all')
import nuxt_plugin_fcPlugin_5a846bc6 from 'nuxt_plugin_fcPlugin_5a846bc6' // Source: ../plugins/fcPlugin (mode: 'all')
import nuxt_plugin_dompurify_9e093c4a from 'nuxt_plugin_dompurify_9e093c4a' // Source: ../plugins/dompurify (mode: 'all')
import nuxt_plugin_storeConfigPlugin_234467e0 from 'nuxt_plugin_storeConfigPlugin_234467e0' // Source: ../plugins/storeConfigPlugin (mode: 'all')
import nuxt_plugin_importmagentocmscomponents_fd02c02c from 'nuxt_plugin_importmagentocmscomponents_fd02c02c' // Source: ../plugins/Magento/import-magento-cms-components (mode: 'all')
import nuxt_plugin_meta_7b794203 from 'nuxt_plugin_meta_7b794203' // Source: ./composition-api/meta.mjs (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root.$options.$nuxt
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"PapierFischer OnlineStore - PapierFischer Shop","htmlAttrs":{"lang":"de"},"meta":[{"charset":"utf8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"description","name":"description","content":"F�ller, Kugelschreiber, Schulranzen, Accessoires vieler Marken online kaufen. Lieferung innerhalb 1- 2 Tagen."},{"hid":"robots","name":"robots","content":"INDEX, FOLLOW"},{"name":"generator","content":"Vue Storefront 2"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"},{"rel":"preconnect","href":"https:\u002F\u002Ffonts.googleapis.com"},{"rel":"preconnect","href":"https:\u002F\u002Ffonts.gstatic.com"}],"script":[{"innerHTML":"\n            if(!(\"gdprAppliesGlobally\" in window)){window.gdprAppliesGlobally=true}if(!(\"cmp_id\" in window)||window.cmp_id\u003C1){window.cmp_id=0}if(!(\"cmp_cdid\" in window)){window.cmp_cdid=\"ecba4482a15cc\"}if(!(\"cmp_params\" in window)){window.cmp_params=\"\"}if(!(\"cmp_host\" in window)){window.cmp_host=\"d.delivery.consentmanager.net\"}if(!(\"cmp_cdn\" in window)){window.cmp_cdn=\"cdn.consentmanager.net\"}if(!(\"cmp_proto\" in window)){window.cmp_proto=\"https:\"}if(!(\"cmp_codesrc\" in window)){window.cmp_codesrc=\"1\"}window.cmp_getsupportedLangs=function(){var b=[\"DE\",\"EN\",\"FR\",\"IT\",\"NO\",\"DA\",\"FI\",\"ES\",\"PT\",\"RO\",\"BG\",\"ET\",\"EL\",\"GA\",\"HR\",\"LV\",\"LT\",\"MT\",\"NL\",\"PL\",\"SV\",\"SK\",\"SL\",\"CS\",\"HU\",\"RU\",\"SR\",\"ZH\",\"TR\",\"UK\",\"AR\",\"BS\"];if(\"cmp_customlanguages\" in window){for(var a=0;a\u003Cwindow.cmp_customlanguages.length;a++){b.push(window.cmp_customlanguages[a].l.toUpperCase())}}return b};window.cmp_getRTLLangs=function(){var a=[\"AR\"];if(\"cmp_customlanguages\" in window){for(var b=0;b\u003Cwindow.cmp_customlanguages.length;b++){if(\"r\" in window.cmp_customlanguages[b]&&window.cmp_customlanguages[b].r){a.push(window.cmp_customlanguages[b].l)}}}return a};window.cmp_getlang=function(j){if(typeof(j)!=\"boolean\"){j=true}if(j&&typeof(cmp_getlang.usedlang)==\"string\"&&cmp_getlang.usedlang!==\"\"){return cmp_getlang.usedlang}var g=window.cmp_getsupportedLangs();var c=[];var f=location.hash;var e=location.search;var a=\"languages\" in navigator?navigator.languages:[];if(f.indexOf(\"cmplang=\")!=-1){c.push(f.substr(f.indexOf(\"cmplang=\")+8,2).toUpperCase())}else{if(e.indexOf(\"cmplang=\")!=-1){c.push(e.substr(e.indexOf(\"cmplang=\")+8,2).toUpperCase())}else{if(\"cmp_setlang\" in window&&window.cmp_setlang!=\"\"){c.push(window.cmp_setlang.toUpperCase())}else{if(a.length\u003E0){for(var d=0;d\u003Ca.length;d++){c.push(a[d])}}}}}if(\"language\" in navigator){c.push(navigator.language)}if(\"userLanguage\" in navigator){c.push(navigator.userLanguage)}var h=\"\";for(var d=0;d\u003Cc.length;d++){var b=c[d].toUpperCase();if(g.indexOf(b)!=-1){h=b;break}if(b.indexOf(\"-\")!=-1){b=b.substr(0,2)}if(g.indexOf(b)!=-1){h=b;break}}if(h==\"\"&&typeof(cmp_getlang.defaultlang)==\"string\"&&cmp_getlang.defaultlang!==\"\"){return cmp_getlang.defaultlang}else{if(h==\"\"){h=\"EN\"}}h=h.toUpperCase();return h};(function(){var y=document;var z=y.getElementsByTagName;var j=window;var r=\"\";var b=\"_en\";if(\"cmp_getlang\" in j){r=j.cmp_getlang().toLowerCase();if(\"cmp_customlanguages\" in j){var g=j.cmp_customlanguages;for(var u=0;u\u003Cg.length;u++){if(g[u].l.toLowerCase()==r){r=\"en\";break}}}b=\"_\"+r}function A(e,D){e+=\"=\";var d=\"\";var m=e.length;var i=location;var E=i.hash;var w=i.search;var s=E.indexOf(e);var C=w.indexOf(e);if(s!=-1){d=E.substring(s+m,9999)}else{if(C!=-1){d=w.substring(C+m,9999)}else{return D}}var B=d.indexOf(\"&\");if(B!=-1){d=d.substring(0,B)}return d}var n=(\"cmp_proto\" in j)?j.cmp_proto:\"https:\";if(n!=\"http:\"&&n!=\"https:\"){n=\"https:\"}var h=(\"cmp_ref\" in j)?j.cmp_ref:location.href;if(h.length\u003E300){h=h.substring(0,300)}var k=y.createElement(\"script\");k.setAttribute(\"data-cmp-ab\",\"1\");var c=A(\"cmpdesign\",\"cmp_design\" in j?j.cmp_design:\"\");var f=A(\"cmpregulationkey\",\"cmp_regulationkey\" in j?j.cmp_regulationkey:\"\");var v=A(\"cmpgppkey\",\"cmp_gppkey\" in j?j.cmp_gppkey:\"\");var p=A(\"cmpatt\",\"cmp_att\" in j?j.cmp_att:\"\");k.src=n+\"\u002F\u002F\"+j.cmp_host+\"\u002Fdelivery\u002Fcmp.php?\"+(\"cmp_id\" in j&&j.cmp_id\u003E0?\"id=\"+j.cmp_id:\"\")+(\"cmp_cdid\" in j?\"&cdid=\"+j.cmp_cdid:\"\")+\"&h=\"+encodeURIComponent(h)+(c!=\"\"?\"&cmpdesign=\"+encodeURIComponent(c):\"\")+(f!=\"\"?\"&cmpregulationkey=\"+encodeURIComponent(f):\"\")+(v!=\"\"?\"&cmpgppkey=\"+encodeURIComponent(v):\"\")+(p!=\"\"?\"&cmpatt=\"+encodeURIComponent(p):\"\")+(\"cmp_params\" in j?\"&\"+j.cmp_params:\"\")+(y.cookie.length\u003E0?\"&__cmpfcc=1\":\"\")+\"&l=\"+r.toLowerCase()+\"&o=\"+(new Date()).getTime();k.type=\"text\u002Fjavascript\";k.async=true;if(y.currentScript&&y.currentScript.parentElement){y.currentScript.parentElement.appendChild(k)}else{if(y.body){y.body.appendChild(k)}else{var q=[\"body\",\"div\",\"span\",\"script\",\"head\"];for(var u=0;u\u003Cq.length;u++){var x=z(q[u]);if(x.length\u003E0){x[0].appendChild(k);break}}}}var o=\"js\";var t=A(\"cmpdebugunminimized\",\"cmpdebugunminimized\" in j?j.cmpdebugunminimized:0)\u003E0?\"\":\".min\";var a=A(\"cmpdebugcoverage\",\"cmp_debugcoverage\" in j?j.cmp_debugcoverage:\"\");if(a==\"1\"){o=\"instrumented\";t=\"\"}var k=y.createElement(\"script\");k.src=n+\"\u002F\u002F\"+j.cmp_cdn+\"\u002Fdelivery\u002F\"+o+\"\u002Fcmp\"+b+t+\".js\";k.type=\"text\u002Fjavascript\";k.setAttribute(\"data-cmp-ab\",\"1\");k.async=true;if(y.currentScript&&y.currentScript.parentElement){y.currentScript.parentElement.appendChild(k)}else{if(y.body){y.body.appendChild(k)}else{var x=z(\"body\");if(x.length==0){x=z(\"div\")}if(x.length==0){x=z(\"span\")}if(x.length==0){x=z(\"ins\")}if(x.length==0){x=z(\"script\")}if(x.length==0){x=z(\"head\")}if(x.length\u003E0){x[0].appendChild(k)}}}})();window.cmp_addFrame=function(b){if(!window.frames[b]){if(document.body){var a=document.createElement(\"iframe\");a.style.cssText=\"display:none\";if(\"cmp_cdn\" in window&&\"cmp_ultrablocking\" in window&&window.cmp_ultrablocking\u003E0){a.src=\"\u002F\u002F\"+window.cmp_cdn+\"\u002Fdelivery\u002Fempty.html\"}a.name=b;a.setAttribute(\"title\",\"Intentionally hidden, please ignore\");a.setAttribute(\"role\",\"none\");a.setAttribute(\"tabindex\",\"-1\");document.body.appendChild(a)}else{window.setTimeout(window.cmp_addFrame,10,b)}}};window.cmp_rc=function(c,b){var j=document.cookie;var g=\"\";var e=0;var f=false;while(j!=\"\"&&e\u003C100){e++;while(j.substr(0,1)==\" \"){j=j.substr(1,j.length)}var h=j.substring(0,j.indexOf(\"=\"));if(j.indexOf(\";\")!=-1){var k=j.substring(j.indexOf(\"=\")+1,j.indexOf(\";\"))}else{var k=j.substr(j.indexOf(\"=\")+1,j.length)}if(c==h){g=k;f=true}var d=j.indexOf(\";\")+1;if(d==0){d=j.length}j=j.substring(d,j.length)}if(!f&&typeof(b)==\"string\"){g=b}return(g)};window.cmp_stub=function(){var a=arguments;__cmp.a=__cmp.a||[];if(!a.length){return __cmp.a}else{if(a[0]===\"ping\"){if(a[1]===2){a[2]({gdprApplies:gdprAppliesGlobally,cmpLoaded:false,cmpStatus:\"stub\",displayStatus:\"hidden\",apiVersion:\"2.2\",cmpId:31},true)}else{a[2](false,true)}}else{if(a[0]===\"getUSPData\"){a[2]({version:1,uspString:window.cmp_rc(\"__cmpccpausps\",\"1---\")},true)}else{if(a[0]===\"getTCData\"){__cmp.a.push([].slice.apply(a))}else{if(a[0]===\"addEventListener\"||a[0]===\"removeEventListener\"){__cmp.a.push([].slice.apply(a))}else{if(a.length==4&&a[3]===false){a[2]({},false)}else{__cmp.a.push([].slice.apply(a))}}}}}}};window.cmp_gpp_ping=function(){return{gppVersion:\"1.1\",cmpStatus:\"stub\",cmpDisplayStatus:\"hidden\",signalStatus:\"not ready\",supportedAPIs:[\"5:tcfcav1\",\"7:usnat\",\"8:usca\",\"9:usva\",\"10:usco\",\"11:usut\",\"12:usct\"],cmpId:31,sectionList:[],applicableSections:[0],gppString:\"\",parsedSections:{}}};window.cmp_gppstub=function(){var c=arguments;__gpp.q=__gpp.q||[];if(!c.length){return __gpp.q}var h=c[0];var g=c.length\u003E1?c[1]:null;var f=c.length\u003E2?c[2]:null;var a=null;var j=false;if(h===\"ping\"){a=window.cmp_gpp_ping();j=true}else{if(h===\"addEventListener\"){__gpp.e=__gpp.e||[];if(!(\"lastId\" in __gpp)){__gpp.lastId=0}__gpp.lastId++;var d=__gpp.lastId;__gpp.e.push({id:d,callback:g});a={eventName:\"listenerRegistered\",listenerId:d,data:true,pingData:window.cmp_gpp_ping()};j=true}else{if(h===\"removeEventListener\"){__gpp.e=__gpp.e||[];a=false;for(var e=0;e\u003C__gpp.e.length;e++){if(__gpp.e[e].id==f){__gpp.e[e].splice(e,1);a=true;break}}j=true}else{__gpp.q.push([].slice.apply(c))}}}if(a!==null&&typeof(g)===\"function\"){g(a,j)}};window.cmp_msghandler=function(d){var a=typeof d.data===\"string\";try{var c=a?JSON.parse(d.data):d.data}catch(f){var c=null}if(typeof(c)===\"object\"&&c!==null&&\"__cmpCall\" in c){var b=c.__cmpCall;window.__cmp(b.command,b.parameter,function(h,g){var e={__cmpReturn:{returnValue:h,success:g,callId:b.callId}};d.source.postMessage(a?JSON.stringify(e):e,\"*\")})}if(typeof(c)===\"object\"&&c!==null&&\"__uspapiCall\" in c){var b=c.__uspapiCall;window.__uspapi(b.command,b.version,function(h,g){var e={__uspapiReturn:{returnValue:h,success:g,callId:b.callId}};d.source.postMessage(a?JSON.stringify(e):e,\"*\")})}if(typeof(c)===\"object\"&&c!==null&&\"__tcfapiCall\" in c){var b=c.__tcfapiCall;window.__tcfapi(b.command,b.version,function(h,g){var e={__tcfapiReturn:{returnValue:h,success:g,callId:b.callId}};d.source.postMessage(a?JSON.stringify(e):e,\"*\")},b.parameter)}if(typeof(c)===\"object\"&&c!==null&&\"__gppCall\" in c){var b=c.__gppCall;window.__gpp(b.command,function(h,g){var e={__gppReturn:{returnValue:h,success:g,callId:b.callId}};d.source.postMessage(a?JSON.stringify(e):e,\"*\")},\"parameter\" in b?b.parameter:null,\"version\" in b?b.version:1)}};window.cmp_setStub=function(a){if(!(a in window)||(typeof(window[a])!==\"function\"&&typeof(window[a])!==\"object\"&&(typeof(window[a])===\"undefined\"||window[a]!==null))){window[a]=window.cmp_stub;window[a].msgHandler=window.cmp_msghandler;window.addEventListener(\"message\",window.cmp_msghandler,false)}};window.cmp_setGppStub=function(a){if(!(a in window)||(typeof(window[a])!==\"function\"&&typeof(window[a])!==\"object\"&&(typeof(window[a])===\"undefined\"||window[a]!==null))){window[a]=window.cmp_gppstub;window[a].msgHandler=window.cmp_msghandler;window.addEventListener(\"message\",window.cmp_msghandler,false)}};window.cmp_addFrame(\"__cmpLocator\");if(!(\"cmp_disableusp\" in window)||!window.cmp_disableusp){window.cmp_addFrame(\"__uspapiLocator\")}if(!(\"cmp_disabletcf\" in window)||!window.cmp_disabletcf){window.cmp_addFrame(\"__tcfapiLocator\")}if(!(\"cmp_disablegpp\" in window)||!window.cmp_disablegpp){window.cmp_addFrame(\"__gppLocator\")}window.cmp_setStub(\"__cmp\");if(!(\"cmp_disabletcf\" in window)||!window.cmp_disabletcf){window.cmp_setStub(\"__tcfapi\")}if(!(\"cmp_disableusp\" in window)||!window.cmp_disableusp){window.cmp_setStub(\"__uspapi\")}if(!(\"cmp_disablegpp\" in window)||!window.cmp_disablegpp){window.cmp_setGppStub(\"__gpp\")};\n          ","type":"text\u002Fjavascript","body":true,"defer":true},{"src":"\u002Fff-web-components\u002Fcustom-elements-es5-adapter.js","body":true,"defer":true},{"src":"\u002Fff-web-components\u002Fwebcomponents-loader.js","body":true,"defer":true},{"src":"\u002Fff-web-components\u002Fbundle.js","body":true,"defer":true},{"hid":"gtm-script","innerHTML":"if(!window._gtm_init){window._gtm_init=1;(function(w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e][p]&&w[e][p]()))?1:0})(window,navigator,'doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled');(function(w,d,s,l,x,y){w[x]={};w._gtm_inject=function(i){if(w.doNotTrack||w[x][i])return;w[x][i]=1;w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.async=true;j.src='https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i;f.parentNode.insertBefore(j,f);};w[y]('GTM-T26F54H')})(window,document,'script','dataLayer','_gtm_ids','_gtm_inject')}"}],"__dangerouslyDisableSanitizers":["script"],"style":[],"noscript":[{"hid":"gtm-noscript","pbody":true,"innerHTML":"\u003Ciframe src=\"https:\u002F\u002Fwww.googletagmanager.com\u002Fns.html?id=GTM-T26F54H&\" height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\" title=\"gtm\"\u003E\u003C\u002Fiframe\u003E"}],"__dangerouslyDisableSanitizersByTagID":{"gtm-script":["innerHTML"],"gtm-noscript":["innerHTML"]}},

    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_76d36eb1 === 'function') {
    await nuxt_plugin_plugin_76d36eb1(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_61dc9896 === 'function') {
    await nuxt_plugin_gtm_61dc9896(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtgooglemaps_2127ab50 === 'function') {
    await nuxt_plugin_nuxtgooglemaps_2127ab50(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_nuxtplugin4d800aaa_1c9599e0 === 'function') {
    await nuxt_plugin_nuxtplugin4d800aaa_1c9599e0(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuescrollto_6895240a === 'function') {
    await nuxt_plugin_vuescrollto_6895240a(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_3d92b2c7 === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_3d92b2c7(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_7e4fbefc === 'function') {
    await nuxt_plugin_pluginutils_7e4fbefc(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_41470572 === 'function') {
    await nuxt_plugin_pluginrouting_41470572(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_d16868f0 === 'function') {
    await nuxt_plugin_pluginmain_d16868f0(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_httpserver_6f06d2cc === 'function') {
    await nuxt_plugin_httpserver_6f06d2cc(app.context, inject)
  }

  if (typeof nuxt_plugin_http_488ac151 === 'function') {
    await nuxt_plugin_http_488ac151(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_9aed9dc2 === 'function') {
    await nuxt_plugin_axios_9aed9dc2(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_googleanalytics_5e6ee4b2 === 'function') {
    await nuxt_plugin_googleanalytics_5e6ee4b2(app.context, inject)
  }

  if (typeof nuxt_plugin_distplugin87244256_77aab419 === 'function') {
    await nuxt_plugin_distplugin87244256_77aab419(app.context, inject)
  }

  if (typeof nuxt_plugin_image_c4dfa3cc === 'function') {
    await nuxt_plugin_image_c4dfa3cc(app.context, inject)
  }

  if (typeof nuxt_plugin_coreplugin1377311c_6ea4e2de === 'function') {
    await nuxt_plugin_coreplugin1377311c_6ea4e2de(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginse2etesting1ce0c5d2_551ed11b === 'function') {
    await nuxt_plugin_pluginse2etesting1ce0c5d2_551ed11b(app.context, inject)
  }

  if (typeof nuxt_plugin_deviceplugin_3ba939aa === 'function') {
    await nuxt_plugin_deviceplugin_3ba939aa(app.context, inject)
  }

  if (typeof nuxt_plugin_tokenexpired_ca1e20ca === 'function') {
    await nuxt_plugin_tokenexpired_ca1e20ca(app.context, inject)
  }

  if (typeof nuxt_plugin_i18n_6a80ea94 === 'function') {
    await nuxt_plugin_i18n_6a80ea94(app.context, inject)
  }

  if (typeof nuxt_plugin_fcPlugin_5a846bc6 === 'function') {
    await nuxt_plugin_fcPlugin_5a846bc6(app.context, inject)
  }

  if (typeof nuxt_plugin_dompurify_9e093c4a === 'function') {
    await nuxt_plugin_dompurify_9e093c4a(app.context, inject)
  }

  if (typeof nuxt_plugin_storeConfigPlugin_234467e0 === 'function') {
    await nuxt_plugin_storeConfigPlugin_234467e0(app.context, inject)
  }

  if (typeof nuxt_plugin_importmagentocmscomponents_fd02c02c === 'function') {
    await nuxt_plugin_importmagentocmscomponents_fd02c02c(app.context, inject)
  }

  if (typeof nuxt_plugin_meta_7b794203 === 'function') {
    await nuxt_plugin_meta_7b794203(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    app,
    router
  }
}

export { createApp, NuxtError }
